var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrapper"},[_c('Loader',{attrs:{"isVisible":_vm.isLoading}}),_c('EventForm',{attrs:{"handleFormChange":_vm.handleFormChange,"formPrefix":'eventGroup',"isGroup":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }